// extracted by mini-css-extract-plugin
module.exports = {"cards_list":"styles_cards_list__Nc30u","card":"styles_card__4mAYE","card__img":"styles_card__img__gx7AX","card__text":"styles_card__text__nz7tc"};